// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/header-columns-bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("images/header-columns-over-bg.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/collapse.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("images/expand.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
IMPORTANT:
In order to preserve the uniform grid appearance, all cell styles need to have padding, margin and border sizes.
No built-in (selected, editable, highlight, flashing, invalid, loading, :focus) or user-specified CSS
classes should alter those!
*/

.slick-header-columns {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x center bottom;
  border-bottom: 1px solid silver;
}

.slick-header-column {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x center bottom;
  border-right: 1px solid silver;
}

.slick-header-column:hover, .slick-header-column-active {
  background: white url(${___CSS_LOADER_URL_REPLACEMENT_1___}) repeat-x center bottom;
}

.slick-headerrow {
  background: #fafafa;
}

.slick-headerrow-column {
  background: #fafafa;
  border-bottom: 0;
  height: 100%;
}

.slick-row.ui-state-active {
  background: #F5F7D7;
}

.slick-row {
  position: absolute;
  background: white;
  border: 0px;
  line-height: 20px;
}

.slick-row.selected {
  z-index: 10;
  background: #DFE8F6;
}

.slick-cell {
  padding-left: 4px;
  padding-right: 4px;
}

.slick-group {
  border-bottom: 2px solid silver;
}

.slick-group-toggle {
  width: 9px;
  height: 9px;
  margin-right: 5px;
}

.slick-group-toggle.expanded {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center;
}

.slick-group-toggle.collapsed {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
}

.slick-group-totals {
  color: gray;
  background: white;
}

.slick-cell.selected {
  background-color: beige;
}

.slick-cell.active {
  border-color: gray;
  border-style: solid;
}

.slick-sortable-placeholder {
  background: silver !important;
}

.slick-row.odd {
  background: #fafafa;
}

.slick-row.ui-state-active {
  background: #F5F7D7;
}

.slick-row.loading {
  opacity: 0.5;
  filter: alpha(opacity = 50);
}

.slick-cell.invalid {
  border-color: red;
  -moz-animation-duration: 0.2s;
  -webkit-animation-duration: 0.2s;
  -moz-animation-name: slickgrid-invalid-hilite;
  -webkit-animation-name: slickgrid-invalid-hilite;  
}

@-moz-keyframes slickgrid-invalid-hilite {
  from { box-shadow: 0 0 6px red; }
  to { box-shadow: none; }
}

@-webkit-keyframes slickgrid-invalid-hilite {
  from { box-shadow: 0 0 6px red; }
  to { box-shadow: none; }
}`, "",{"version":3,"sources":["webpack://./node_modules/slickgrid-qgridnext/slick-default-theme.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAED;EACE,0EAAsE;EACtE,+BAA+B;AACjC;;AAEA;EACE,0EAAsE;EACtE,8BAA8B;AAChC;;AAEA;EACE,gFAAiF;AACnF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2EAA4D;AAC9D;;AAEA;EACE,2EAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gCAAgC;EAChC,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,gBAAgB,EAAE;AACzB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,gBAAgB,EAAE;AACzB","sourcesContent":["/*\nIMPORTANT:\nIn order to preserve the uniform grid appearance, all cell styles need to have padding, margin and border sizes.\nNo built-in (selected, editable, highlight, flashing, invalid, loading, :focus) or user-specified CSS\nclasses should alter those!\n*/\n\n.slick-header-columns {\n  background: url('images/header-columns-bg.gif') repeat-x center bottom;\n  border-bottom: 1px solid silver;\n}\n\n.slick-header-column {\n  background: url('images/header-columns-bg.gif') repeat-x center bottom;\n  border-right: 1px solid silver;\n}\n\n.slick-header-column:hover, .slick-header-column-active {\n  background: white url('images/header-columns-over-bg.gif') repeat-x center bottom;\n}\n\n.slick-headerrow {\n  background: #fafafa;\n}\n\n.slick-headerrow-column {\n  background: #fafafa;\n  border-bottom: 0;\n  height: 100%;\n}\n\n.slick-row.ui-state-active {\n  background: #F5F7D7;\n}\n\n.slick-row {\n  position: absolute;\n  background: white;\n  border: 0px;\n  line-height: 20px;\n}\n\n.slick-row.selected {\n  z-index: 10;\n  background: #DFE8F6;\n}\n\n.slick-cell {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.slick-group {\n  border-bottom: 2px solid silver;\n}\n\n.slick-group-toggle {\n  width: 9px;\n  height: 9px;\n  margin-right: 5px;\n}\n\n.slick-group-toggle.expanded {\n  background: url(images/collapse.gif) no-repeat center center;\n}\n\n.slick-group-toggle.collapsed {\n  background: url(images/expand.gif) no-repeat center center;\n}\n\n.slick-group-totals {\n  color: gray;\n  background: white;\n}\n\n.slick-cell.selected {\n  background-color: beige;\n}\n\n.slick-cell.active {\n  border-color: gray;\n  border-style: solid;\n}\n\n.slick-sortable-placeholder {\n  background: silver !important;\n}\n\n.slick-row.odd {\n  background: #fafafa;\n}\n\n.slick-row.ui-state-active {\n  background: #F5F7D7;\n}\n\n.slick-row.loading {\n  opacity: 0.5;\n  filter: alpha(opacity = 50);\n}\n\n.slick-cell.invalid {\n  border-color: red;\n  -moz-animation-duration: 0.2s;\n  -webkit-animation-duration: 0.2s;\n  -moz-animation-name: slickgrid-invalid-hilite;\n  -webkit-animation-name: slickgrid-invalid-hilite;  \n}\n\n@-moz-keyframes slickgrid-invalid-hilite {\n  from { box-shadow: 0 0 6px red; }\n  to { box-shadow: none; }\n}\n\n@-webkit-keyframes slickgrid-invalid-hilite {\n  from { box-shadow: 0 0 6px red; }\n  to { box-shadow: none; }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
